import TableCellRenderer from '../../../../table/TableCellRenderer'

export default class EmptyCellRenderer extends TableCellRenderer {
    constructor(additionalClass = '') {
        super()
        this.additionalClassName = additionalClass
    }
    generateContent(cell) {
        cell.innerHTML = ''
    }

    getCellClassName() {
        return ['emptyCell', this.additionalClassName]
    }
}



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/userList/table/EmptyCellRenderer.js